import { httpClient } from '#shared/index'
import type { UpdateAlertsPayload } from '../model/update-alerts-payload'

export async function updateAlerts(payload: UpdateAlertsPayload) {
  await httpClient.patch('alerts', {
    json: payload,
    requireAuth: true,
  })
}
